<loren-page-content (window:resize)="resize()">
  @if(loadingData()) {
  <div class="vertically-centered" style="justify-content: center">
    <mat-spinner></mat-spinner>
  </div>
  } @else {
  <div class="loren-dashboard-header">
    <mat-card-title>
      {{ "sidenav.assets" | transloco }} ({{ totalNumOfAssets() }})
    </mat-card-title>
    <div class="loren-dashboard-header-actions">
        <button matButton="filled" (click)="openWidgetsDialog()" class="btn-secondary">
            <mat-icon>low_priority</mat-icon>
            {{ "dashboard.reorder" | transloco }}
        </button>
        <button
                matButton="filled"
                class="btn-green"
                *lorenShowForPrivileges="[privileges.WRITE_ASSET]"
                (click)="handleDefineAsset()">
            {{ "asset.define_asset_title" | transloco }}
        </button>
    </div>
  </div>
  @if(!loadingData() && !showCreateAssetState()) {
  <div class="loren-dashboard-actions">
    <div class="loren-dashboard-actions-buttons">
      @if(allowDeviceReport() && !isHandset) {
      <button matButton="filled" class="btn-secondary" (click)="downloadReport()">
        {{ "dashboard.download_report" | transloco }}
      </button>
      } @if(allowGroups() && groups().length) {
      <button matButton="filled" class="btn-secondary" [matMenuTriggerFor]="groupFilters">
        {{ "dashboard.filter_by_group" | transloco }}
      </button>
      }
    </div>
    @if(!isHandset) {
    <div class="loren-dashboard-actions-views">
      {{ "asset.switch_view" | transloco }}:
      <button
        mat-icon-button
        [matTooltip]="'tooltips.list_view' | transloco"
        (click)="handleCardViewChange(viewTypes.ROW)">
        <mat-icon
          class="loren-dashboard-actions-views-icon"
          [ngClass]="{
            'loren-dashboard-actions-views-icon--active':
              currentViewType() === viewTypes.ROW
          }"
          >view_agenda</mat-icon
        >
      </button>
      <button
        mat-icon-button
        [matTooltip]="'tooltips.matrix_view' | transloco"
        (click)="handleCardViewChange(viewTypes.GRID)">
        <mat-icon
          class="loren-dashboard-actions-views-icon"
          [ngClass]="{
            'loren-dashboard-actions-views-icon--active':
              currentViewType() === viewTypes.GRID
          }"
          >view_module</mat-icon
        >
      </button>
      <button
        mat-icon-button
        [matTooltip]="'tooltips.table_view' | transloco"
        (click)="handleCardViewChange(viewTypes.TABLE)">
        <mat-icon
          class="loren-dashboard-actions-views-icon"
          [ngClass]="{
            'loren-dashboard-actions-views-icon--active':
              currentViewType() === viewTypes.TABLE
          }"
          >table_chart</mat-icon
        >
      </button>
    </div>
    }
  </div>
  @if(allCardModels().length) {
  <div
    class="loren-dashboard-assets"
    [ngClass]="{
      'loren-dashboard-assets-grid':
        currentViewType() === viewTypes.GRID || isHandset,
      'loren-dashboard-assets-row': currentViewType() === viewTypes.ROW,
      'loren-dashboard-assets-table': currentViewType() === viewTypes.TABLE
    }">
    @for (model of allCardModels(); track model; let first = $first, last =
    $last) {
    <loren-asset-card
      class="loren-dashboard-assets-card"
      [ngClass]="{
        'loren-dashboard-assets-card-one': model.metering.length === 1,
        'loren-dashboard-assets-card-two': model.metering.length === 2,
        'loren-dashboard-assets-card-three': model.metering.length === 3,
        'loren-dashboard-assets-card-four': model.metering.length === 4,
        'loren-dashboard-asset-card-table-view':
          !isHandset && currentViewType() === viewTypes.TABLE
      }"
      [assetId]="model.id"
      [first]="first"
      [last]="last"
      [tableView]="!isHandset && currentViewType() === viewTypes.TABLE"
      [rowView]="
        !isHandset && currentViewType() === viewTypes.ROW"
     />
    }
  </div>
  @if(totalNumOfAssets() > assetsPerPage() || currentPageIndex() > 0) {
  <div class="loren-dashboard-pagination row no-gutters">
    <div class="col">
      <mat-paginator
        [hidePageSize]="true"
        [length]="totalNumOfAssets()"
        [pageSize]="assetsPerPage()"
        [pageIndex]="currentPageIndex()"
        [showFirstLastButtons]="true"
        (page)="pageChange($event)" />
    </div>
  </div>

  } }@else {
  <p>{{ "dashboard.no_filtered_assets" | transloco }}</p>
  } } @if (showCreateAssetState()) {
    <loren-dashboard-create-asset-state (defineAssetClick)="handleDefineAsset()" />
  } }
</loren-page-content>

<mat-menu #groupFilters="matMenu">
  <ng-template matMenuContent>
    <loren-filters
      [initiallySelected]="activeGroupFilters()"
      [placeholder]="'alarms.search_parameters' | transloco"
      [items]="groupsFilter()"
      [showSearch]="false"
      (selectionSubmitted)="filter($event)">
    </loren-filters>
  </ng-template>
</mat-menu>
